// extracted by mini-css-extract-plugin
export default {"stickyHeader":"style_stickyHeader__-HfNu"};